import { Collapse } from '@mui/material'
import { ButtonTypes } from '@paywithextend/components'
import cn from 'classnames'
import Button from 'ext-ui/components/Button/Button'
import React, { useMemo, useState } from 'react'
import SvgChevronUp from 'src/components/Svgs/SvgChevronUp'
import { useClickOutside } from 'src/hooks'

import styles from './UtilityToolbarDropdown.style'

export interface UtilityToolbarDropdownProps {
  buttonText: string | React.ReactElement
  dropdown: React.ReactElement<UtilityToolbarDropdownChildProps>
  image?: React.ReactElement
  testId?: string
  selected?: boolean
}

export interface UtilityToolbarDropdownChildProps {
  open?: boolean
  close?: () => void
}

const UtilityToolbarDropdown: React.FC<UtilityToolbarDropdownProps> = ({
  buttonText,
  dropdown,
  image,
  testId,
  selected,
}): React.ReactElement => {
  const [isOpen, setIsOpen] = useState(false)

  const dropdownRef = useClickOutside(() => {
    setIsOpen(false)
  })

  const dropdownControls = useMemo(() => {
    return {
      open: isOpen,
      close: () => setIsOpen(false),
    }
  }, [isOpen])

  const dropdownWithControls = React.isValidElement(dropdown)
    ? React.cloneElement(dropdown, dropdownControls)
    : dropdown

  return (
    <div
      className={cn('UtilityToolbarDropdown', { selected: selected })}
      css={styles}
      ref={dropdownRef}
    >
      <div className="handleContainer">
        <Button
          className={cn('UtilityToolbarDropdown', 'button', { selected: selected })}
          data-testid={testId}
          type={ButtonTypes.button}
          variant={"toolbar"}
          dropShadow={false}
          onClick={(): void => {
            setIsOpen(!isOpen)
          }}
        >
          <span className="flex-row align-center">
            {image && (
              <span className="UtilityToolbarDropdown image">
                {image}
              </span>
            )}
            <span className="UtilityToolbarDropdown label">
              {buttonText}
            </span>
            <SvgChevronUp
              width={16}
              height={16}
              className={cn('icon', { open: isOpen })}
            />
          </span>
        </Button>
      </div>
      <div className="UtilityToolbarDropdown dropdownContainer">
        <Collapse in={isOpen}>{dropdownWithControls}</Collapse>
      </div>
    </div>
  )
}

export default UtilityToolbarDropdown
